import React from 'react';
import { useNavigate } from 'react-router-dom';
import { User } from '../../services/authService';
import PageHeader from '../common/PageHeader';
import './HindiLearn.css';

interface HindiLearnProps {
  user: User | null;
  onClose: () => void;
  onToggleSidebar: () => void;
}

const HindiLearn: React.FC<HindiLearnProps> = ({
  onToggleSidebar
}) => {
  const navigate = useNavigate();

  return (
    <div className="hindi-learn-container">
      <PageHeader
        onToggleSidebar={onToggleSidebar}
        centerContent={
          <h1 className="page-header-center-title">
            Hindi Learning
          </h1>
        }
      />

      <div className="hindi-learn-content">
        <div className="hindi-learn-section">
          <div className="hindi-learn-section-header">/modules</div>
          <div className="hindi-learn-buttons">
            <button
              className="hindi-learn-module-btn hindi-learn-reading-btn"
              onClick={() => navigate('/hindi/reading')}
            >
              <span className="hindi-learn-module-icon">📖</span>
              <span className="hindi-learn-module-title">Reading</span>
              <span className="hindi-learn-module-description">
                AI-powered Hindi reading lessons with interactive vocabulary
              </span>
            </button>
            <button
              className="hindi-learn-module-btn hindi-learn-character-btn"
              onClick={() => navigate('/hindi/character')}
            >
              <span className="hindi-learn-module-icon">✍️</span>
              <span className="hindi-learn-module-title">Character Writing</span>
              <span className="hindi-learn-module-description">
                Practice writing Hindi characters with AI-powered verification
              </span>
            </button>
            <button
              className="hindi-learn-module-btn hindi-learn-alphabet-btn"
              onClick={() => navigate('/hindi/alphabet')}
            >
              <span className="hindi-learn-module-icon">🔤</span>
              <span className="hindi-learn-module-title">Alphabet</span>
              <span className="hindi-learn-module-description">
                Browse all Hindi alphabet characters, matras, and basic combinations
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HindiLearn;

